<script>
export default {
  name: 'SectionNavItem',

  props: {
    hasSublist: {
      type: Boolean,
      required: true
    },
    startsOpen: {
      type: Boolean,
      required: true
    },
    isSm: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      sublistOpen: this.startsOpen
    }
  },
  
  methods: {
    handleSublistToggle(e) {
      this.sublistOpen = !this.sublistOpen
      this.$emit('sublist-toggle', {
        listEl: this.$refs.sublist,
        btnEl: e.target,
        isOpen: this.sublistOpen
      })
    }
  },

  watch: {
    isSm(isSm) {
      // recalculate max-height
      if (this.hasSublist && this.sublistOpen && !isSm) this.$refs.sublist.style.maxHeight = this.$refs.sublist.scrollHeight + 'px'
    }
  },

  mounted() {
    // initialize WAI-ARIA attributes and visibility
    if (this.hasSublist) this.$refs.sublist.setAttribute('aria-hidden', !this.sublistOpen)

    if (this.hasSublist && this.startsOpen) {
      this.$refs.sublist.style.maxHeight = this.$refs.sublist.scrollHeight + 'px'
      this.$refs.sublist.classList.remove('starts-open')
      this.$refs.sublist.classList.add('is-visible')
    }
  }

}
</script>



// WEBPACK FOOTER //
// js/SectionNavItem.vue